export const genderOptions = [
    {
        id : 1 ,
        key : 'Male' ,
        value : 'male'
    } ,
    {
        id : 2 ,
        key : 'Female' ,
        value : 'female'
    } ,
    {
        id : 3 ,
        key : 'Other' ,
        value : 'other'
    } ,
]



   export const DOCUMENT_TYPE_MAP = {
  Cnic: "cnic",
  Passport: "passport",
  "Driving License": "driving_license",
  "Utility Bill": "utility_bill",
  Picture: "picture",
  "Application Form": "application_form",
  "Reference Letter": "reference_letter",
  "Payment Receipt": "payment_receipt",
  "Payment Plan": "payment_plan",
  "Booking Form": "booking_form",
  "Sale Agreement": "sale_agreement",
  "Purchase Agreement": "purchase_agreement",
  "Allotment Letter": "allotment_letter",
  "Intimation Letter": "intimation_letter",
  "Transfer Letter": "transfer_letter",
  Noc: "noc",
  "Ownership Letter": "ownership_letter",
  Other: "other",
};

export const Provisional_Types = [
  'Pending Clearance',
  'Cleared',
  'Bounced',
  'Cancelled'
];




export const Installment_Status = [
  'un-paid', 'overdue','pertially_paid','defaulted', 'paid', 'cancelled'
];

export const Inventory_Status = [
  'not_assigned', 'assigned', 'full_paid',
];




export const Payment_Types = [
'Pending','Approved','Rejected','Voided','Refunded'
];



export const DOCUMENT_TYPES = [
  "cnic",
  "passport",
  "driving_license",
  "utility_bill",
  "picture",
  "application_form",
  "reference_letter",
  "payment_receipt",
  "payment_plan",
  "booking_form",
  "sale_agreement",
  "purchase_agreement",
  "allotment_letter",
  "intimation_letter",
  "transfer_letter",
  "noc",
  "ownership_letter",
  "other"
];





export const  RECORD_TYPES = [
  "Cnic",
  "Passport",
  "Driving License",
  "Utility Bill",
  "Picture",
  "Application Form",
  "Reference Letter",
  "Payment Receipt",
  "Payment Plan",
  "Booking Form",
  "Sale Agreement",
  "Purchase Agreement",
  "Allotment Letter",
  "Intimation Letter",
  "Transfer Letter",
  "Noc",
  "Ownership Letter",
  "Other"
];


export const INVENTORY_TYPES = [
  "commercial",
  "raesidential",
];



export const PAYMENT_TYPES = [
  { value: "full_payment", label: "Full Payment" },
  { value: "installment", label: "Installment" }
];


  export const Installment_Options = [
  { value: 1, label: "1 installment" },
  { value: 2, label: "2 installment" },
  { value: 3, label: "3 installment" },
  { value: 4, label: "4 installment" },
  { value: 5, label: "5 installment" },
  { value: 6, label: "6 installment" },
  { value: 7, label: "7 installment" },
  { value: 8, label: "8 installment" },
  { value: 9, label: "9 installment" },
  { value: 10, label: "10 installment" },
  { value: 11, label: "11 installment" },
  { value: 12, label: "12 installment" },
  { value: 13, label: "13 installment" },
  { value: 14, label: "14 installment" },
  { value: 15, label: "15 installment" },
  { value: 16, label: "16 installment" },
  { value: 17, label: "17 installment" },
  { value: 18, label: "18 installment" },
  { value: 19, label: "19 installment" },
  { value: 20, label: "20 installment" },
  { value: 21, label: "21 installment" },
  { value: 22, label: "22 installment" },
  { value: 23, label: "23 installment" },
  { value: 24, label: "24 installment" },
  { value: 25, label: "25 installment" },
  { value: 26, label: "26 installment" },
  { value: 27, label: "27 installment" },
  { value: 28, label: "28 installment" },
  { value: 29, label: "29 installment" },
  { value: 30, label: "30 installment" },
  { value: 31, label: "31 installment" },
  { value: 32, label: "32 installment" },
  { value: 33, label: "33 installment" },
  { value: 34, label: "34 installment" },
  { value: 35, label: "35 installment" },
  { value: 36, label: "36 installment" },
  { value: 37, label: "37 installment" },
  { value: 38, label: "38 installment" },
  { value: 39, label: "39 installment" },
  { value: 40, label: "40 installment" },
  { value: 41, label: "41 installment" },
  { value: 42, label: "42 installment" },
  { value: 43, label: "43 installment" },
  { value: 44, label: "44 installment" },
  { value: 45, label: "45 installment" },
  { value: 46, label: "46 installment" },
  { value: 47, label: "47 installment" },
  { value: 48, label: "48 installment" },
  { value: 49, label: "49 installment" },
  { value: 50, label: "50 installment" },
];



export const Installment_Durtion = [
  { value: "Quarterly", label: "Quarterly" }
];





export const Monthly_Durtion = [
  { value: "Monthly", label: "Monthly" }
];





export const Yearly_Durtion = [
  { value: "Half Yearly", label: "Biannual" }
];

export const Monthly_Balloon_Durtion = [
  { value: "Monthly + Half Yearly", label: "Monthly + Half Yearly" }
];

export const Quarterly_Balloon_Durtion = [
  { value: "Quarterly + Balloon", label: "Quarterly + Balloon" }
];

export const Monthly_Quarterly_Durtion = [
  { value: "Monthly + Quarterly", label: "Monthly + Quarterly" }
];


export const Installment_TYPES = [
  { value: "full_payment", label: "Full Payment" },
  { value: "monthly_balloon_3year_installment", label: "Monthly + Balloon 3 Year Residential " },
  { value: "new_3_year_installment", label: "New 3 Year Residential " },
  { value: "1_year_installment", label: "1 Year Commercial" },
  { value: "3_year_installment", label: "3 Year Residential " },
  { value: "2_year_installment", label: "Others" }

];





export const  Applicant_TYPES = [
  { value: "self", label: "Self" },
  { value: "joint", label: "Joint" }
];




export const  Applicant_TYPES_self = [
  { value: "self", label: "Self" },

];

export const reportTypeOptions = [
  { value: "due_installments", label: "Due Installments", hint: "" },
  { value: "sold_inventories", label: "Inventories Sold", hint: "" },
  { value: "payments_received", label: "Payments Received", hint: "" },
  { value: "future_cash_flow", label: "Future Cash Flow", hint: "" },
];

export const paymentMethodOptions = [
  { value: "", label: "All Methods" },
  { value: "online_transfer", label: "Online Transfer" },
  { value: "cheque", label: "Cheque" },
  { value: "pay_order", label: "Pay Order" },
  { value: "cash", label: "Cash" },
  { value: "cheque1", label: "Cheque 1" },
  { value: "cheque2", label: "Cheque 2" },
  { value: "cheque3", label: "Cheque 3" },
  { value: "other", label: "Other" },
];
